var ImgContain   = require("./img-contain/script");
var ImgCover     = require("./img-cover/script");
var LazyImg      = require("./lazy-img/script");
var LoopingVideo = require("./looping-video/script");
var PlyrVideo    = require("./plyr-video/script");

window.SETTINGS.domScan.addContainer($('body'), function($scanContainer){

	window.SETTINGS.domScan.addElement($scanContainer, '[data-img-contain]', function(){
		new ImgContain(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-img-cover]', function(){
		new ImgCover(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-lazy-img]', function(){
		new LazyImg(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-looping-video]', function(){
		new LoopingVideo(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-plyr-video]', function(){
		new PlyrVideo(this);
	});

});
